<template>
    <div class="d-flex justify-content-center flex-wrap py-3">
        <div class="col-12 col-sm-4 d-flex flex-wrap bg-white shadow rounded p-5">
            <div class="col-12 text-center mb-4">
                <span class="text-third">
                    <i class="fa-solid fa-envelope-open-text text-icon"></i>
                </span>
            </div>
            <div class="col-12">
                <p>
                    {{ $t('Auth.EmailUnconfirmed.confirm_required') }}
                </p>
                <p class="mb-2">
                    {{ $t('Auth.EmailUnconfirmed.email_not_received') }}
                </p>
            </div>
            <form @submit.prevent="resendConfirmationEmail" class="col-12 d-flex flex-wrap mb-4">
                <div class="col-12 form-field mb-2">
                    <label for="email" class="mb-2">
                        <small :class="{'text-danger' : errors.email}">
                            {{ $t('Auth.ResendConfirmationEmail.email') }}
                        </small>
                        <span v-if="errors.email" class="text-danger mx-2">
                            -
                        </span>
                        <small v-if="errors.email" class="text-danger">
                            {{ errors.email }}
                        </small>
                    </label>
                    <input v-model="email" @focus="errors.email = null" name="email" type="email" class="form-control" id="email" :placeholder="$t('Auth.ResendConfirmationEmail.insert_email')" :class="{'text-danger border-danger' : errors.email}">
                </div>
                <div class="col-12">
                    <button type="submit" class="btn btn-auth btn-auth-second w-100">
                        {{ $t('Auth.ResendConfirmationEmail.send') }}
                    </button>
                </div>
            </form>
            <div class="col-12">
                <p>
                    {{ $t('Auth.EmailUnconfirmed.login_again') }}
                </p>
            </div>
            <div class="col-12">
                <router-link to="/" class="btn btn-auth btn-auth-white w-100">
                    {{ $t('Auth.EmailUnconfirmed.back_to_login') }}
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
    name: 'EmailUnconfirmed',
    computed: {
        ...mapGetters(['apiPath', 'omsApiKey']),
    },
    data() {
        return {
            email: null,
            errors: {}
        }
    },
    methods: {
        ...mapMutations(['setErrorFromServer']),
        resendConfirmationEmail() {
            this.$http
                .post(`${this.apiPath}/email/send_email_confirmation_request`, { email: this.email }, {
                    headers: {
                        'x-api-key': this.omsApiKey
                    }
                }).then((res) => {
                    if (res.data.errors) {
                        var errors = res.data.errors
                        for (var i = 0; i < errors.length; i++) {
                            var error = errors[i]
                            if (error.path == 'email') {
                                this.errors.email = this.$t(`Auth.ResendConfirmationEmail.errors.email.${error.msg}`)
                            }
                        }
                        this.$toast.error(this.$t('toast.fields_errors'))
                        return
                    }
                    if (res.data.data) {
                        this.$toast.success(`${this.$t('toast.sent_email')} <strong>${res.data.data.to}</strong> <h6>${this.$t('toast.confirm_email')}</h6>`)
                        this.$router.replace('/')
                        return
                    }
                    switch (res.data) {
                        case 'No Account Found':
                            this.errors.email = this.$t('Auth.ResendConfirmationEmail.errors.email.NoAccountFound')
                            this.$toast.error(this.$t('Auth.ResendConfirmationEmail.errors.email.NoAccountFound'))
                            break
                        case 'Account Already Confirmed':
                            this.errors.email = this.$t('Auth.ResendConfirmationEmail.errors.email.AccountAlreadyConfirmed')
                            this.$toast.error(this.$t('Auth.ResendConfirmationEmail.errors.email.AccountAlreadyConfirmed'))
                            break
                    }
                })
                .catch((err) => {
                    this.setErrorFromServer(err.message)
                })
        }
    }
}
</script>